/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Androidbeta_Description1Inputs */

const id_forms_androidbeta_description1 = /** @type {(inputs: Forms_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk dengan Google untuk mendaftar beta tertutup. Kami hanya memerlukan alamat email Anda.`)
};

const ms_forms_androidbeta_description1 = /** @type {(inputs: Forms_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log masuk dengan Google untuk mendaftar beta tertutup. Kami hanya memerlukan alamat e-mel anda.`)
};

const da_forms_androidbeta_description1 = /** @type {(inputs: Forms_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log ind med Google for at registrere dig til den lukkede beta. Vi har kun brug for din e-mailadresse.`)
};

const de_forms_androidbeta_description1 = /** @type {(inputs: Forms_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melden Sie sich mit Google an, um sich für die geschlossene Beta zu registrieren. Wir benötigen nur Ihre E-Mail-Adresse.`)
};

const en_us2_forms_androidbeta_description1 = /** @type {(inputs: Forms_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in with Google to register for the closed beta. We only need your email address.`)
};

const es_es2_forms_androidbeta_description1 = /** @type {(inputs: Forms_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesión con Google para registrarte en la beta cerrada. Solo necesitamos tu correo electrónico.`)
};

const es_mx2_forms_androidbeta_description1 = /** @type {(inputs: Forms_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesión con Google para registrarte en la beta cerrada. Solo necesitamos tu correo electrónico.`)
};

const fil_forms_androidbeta_description1 = /** @type {(inputs: Forms_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag-sign in gamit ang Google upang magrehistro para sa closed beta. Ang kailangan lang namin ay ang iyong email address.`)
};

const fr_forms_androidbeta_description1 = /** @type {(inputs: Forms_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectez-vous avec Google pour vous inscrire à la bêta fermée. Nous avons seulement besoin de votre adresse e-mail.`)
};

const it_forms_androidbeta_description1 = /** @type {(inputs: Forms_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi con Google per registrarti alla beta chiusa. Abbiamo bisogno solo del tuo indirizzo email.`)
};

const hu_forms_androidbeta_description1 = /** @type {(inputs: Forms_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jelentkezz be Google-lal a zárt bétára való regisztrációhoz. Csak az e-mail címedre van szükségünk.`)
};

const nl_forms_androidbeta_description1 = /** @type {(inputs: Forms_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log in met Google om je te registreren voor de gesloten bèta. We hebben alleen je e-mailadres nodig.`)
};

const no_forms_androidbeta_description1 = /** @type {(inputs: Forms_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logg inn med Google for å registrere deg for den lukkede betaen. Vi trenger bare e-postadressen din.`)
};

const pl_forms_androidbeta_description1 = /** @type {(inputs: Forms_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaloguj się przez Google, aby zarejestrować się w zamkniętej becie. Potrzebujemy tylko Twojego adresu e-mail.`)
};

const pt_br2_forms_androidbeta_description1 = /** @type {(inputs: Forms_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in with Google to register for the closed beta. We only need your email address.`)
};

const pt_forms_androidbeta_description1 = /** @type {(inputs: Forms_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicie sessão com o Google para se registar na beta fechada. Apenas precisamos do seu email.`)
};

const ro_forms_androidbeta_description1 = /** @type {(inputs: Forms_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autentifică-te cu Google pentru a te înregistra pentru beta închisă. Avem nevoie doar de adresa ta de email.`)
};

const fi_forms_androidbeta_description1 = /** @type {(inputs: Forms_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirjaudu sisään Google-tilillä rekisteröityäksesi suljettuun betaan. Tarvitsemme vain sähköpostiosoitteesi.`)
};

const sv_forms_androidbeta_description1 = /** @type {(inputs: Forms_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logga in med Google för att registrera dig för den slutna betan. Vi behöver bara din e-postadress.`)
};

const vi_forms_androidbeta_description1 = /** @type {(inputs: Forms_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng nhập bằng Google để đăng ký beta kín. Chúng tôi chỉ cần địa chỉ email của bạn.`)
};

const tr_forms_androidbeta_description1 = /** @type {(inputs: Forms_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapalı beta için kaydolmak üzere Google ile oturum açın. Yalnızca e-posta adresinize ihtiyacımız var.`)
};

const cs_forms_androidbeta_description1 = /** @type {(inputs: Forms_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přihlaste se přes Google k registraci do uzavřené beta verze. Potřebujeme pouze váš e-mail.`)
};

const bg_forms_androidbeta_description1 = /** @type {(inputs: Forms_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Влезте с Google, за да се регистрирате за затворената бета версия. Нуждаем се само от вашия имейл адрес.`)
};

const ru_forms_androidbeta_description1 = /** @type {(inputs: Forms_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Войдите через Google, чтобы зарегистрироваться в закрытом бета-тесте. Нам нужен только ваш адрес электронной почты (gmail).`)
};

const uk_forms_androidbeta_description1 = /** @type {(inputs: Forms_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увійдіть через Google, щоб зареєструватися в закритій бета-версії. Нам потрібна лише ваша електронна адреса.`)
};

const ar_forms_androidbeta_description1 = /** @type {(inputs: Forms_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سجل الدخول باستخدام Google للتسجيل في الإصدار التجريبي المغلق. نحتاج فقط إلى بريدك الإلكتروني.`)
};

const hi_forms_androidbeta_description1 = /** @type {(inputs: Forms_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google से साइन इन करें।`)
};

const th_forms_androidbeta_description1 = /** @type {(inputs: Forms_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลงชื่อเข้าใช้ด้วย Google เพื่อลงทะเบียนสำหรับเบต้าปิด เราต้องการเพียงที่อยู่อีเมลของคุณ`)
};

const ja_forms_androidbeta_description1 = /** @type {(inputs: Forms_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google でサインインしてクローズドベータ版に登録。メールアドレスのみ必要です。`)
};

const zh_cn2_forms_androidbeta_description1 = /** @type {(inputs: Forms_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in with Google to register for the closed beta. We only need your email address.`)
};

const zh_hant1_forms_androidbeta_description1 = /** @type {(inputs: Forms_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in with Google to register for the closed beta. We only need your email address.`)
};

const ko_forms_androidbeta_description1 = /** @type {(inputs: Forms_Androidbeta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in with Google to register for the closed beta. We only need your email address.`)
};

/**
* | output |
* | --- |
* | "Sign in with Google to register for the closed beta. We only need your email address." |
*
* @param {Forms_Androidbeta_Description1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_androidbeta_description1 = /** @type {((inputs?: Forms_Androidbeta_Description1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Androidbeta_Description1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_androidbeta_description1(inputs)
	if (locale === "ms") return ms_forms_androidbeta_description1(inputs)
	if (locale === "da") return da_forms_androidbeta_description1(inputs)
	if (locale === "de") return de_forms_androidbeta_description1(inputs)
	if (locale === "en-US") return en_us2_forms_androidbeta_description1(inputs)
	if (locale === "es-ES") return es_es2_forms_androidbeta_description1(inputs)
	if (locale === "es-MX") return es_mx2_forms_androidbeta_description1(inputs)
	if (locale === "fil") return fil_forms_androidbeta_description1(inputs)
	if (locale === "fr") return fr_forms_androidbeta_description1(inputs)
	if (locale === "it") return it_forms_androidbeta_description1(inputs)
	if (locale === "hu") return hu_forms_androidbeta_description1(inputs)
	if (locale === "nl") return nl_forms_androidbeta_description1(inputs)
	if (locale === "no") return no_forms_androidbeta_description1(inputs)
	if (locale === "pl") return pl_forms_androidbeta_description1(inputs)
	if (locale === "pt-BR") return pt_br2_forms_androidbeta_description1(inputs)
	if (locale === "pt") return pt_forms_androidbeta_description1(inputs)
	if (locale === "ro") return ro_forms_androidbeta_description1(inputs)
	if (locale === "fi") return fi_forms_androidbeta_description1(inputs)
	if (locale === "sv") return sv_forms_androidbeta_description1(inputs)
	if (locale === "vi") return vi_forms_androidbeta_description1(inputs)
	if (locale === "tr") return tr_forms_androidbeta_description1(inputs)
	if (locale === "cs") return cs_forms_androidbeta_description1(inputs)
	if (locale === "bg") return bg_forms_androidbeta_description1(inputs)
	if (locale === "ru") return ru_forms_androidbeta_description1(inputs)
	if (locale === "uk") return uk_forms_androidbeta_description1(inputs)
	if (locale === "ar") return ar_forms_androidbeta_description1(inputs)
	if (locale === "hi") return hi_forms_androidbeta_description1(inputs)
	if (locale === "th") return th_forms_androidbeta_description1(inputs)
	if (locale === "ja") return ja_forms_androidbeta_description1(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_androidbeta_description1(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_androidbeta_description1(inputs)
	return ko_forms_androidbeta_description1(inputs)
});
export { forms_androidbeta_description1 as "forms.androidBeta.description" }